export { Cmarkdownmap } from './Cmarkdownmap';
export type { CmarkdownmapProps } from './Cmarkdownmap';
/** The block's restatement surfaces, so an embedder can name the ones its own
 *  chrome already carries via `suppressedRestatements`. */
export { MapPinRestatement } from './map-render-model';
/** The two live presentation axes — the at-rest pin, and how much of the
 *  basemap's own places show behind it. An embedder that wants the shipped map
 *  imports none of this: the provider is an override, and a block with no
 *  provider over it resolves to `MAP_PRESENTATION_DEFAULT`. The chosen-pin
 *  treatment and the three cartography inks are baked and carry no control. */
export {
  CmarkdownmapPresentationProvider,
  MAP_PIN_IDLE_VARIANTS,
  MAP_PRESENTATION_DEFAULT,
  MapPinIdleVariant,
  useMapAmbientPoiVariant,
  useMapPinIdleVariant,
} from './map-presentation.context';
export type { MapPresentation } from './map-presentation.context';
export {
  MAP_AMBIENT_POI_VARIANTS,
  MapAmbientPoiVariant,
} from './map-ambient-poi';
/** The third live axis: which of the three ambient-POI overlaps the canvas
 *  resolves. Unlike the two above it changes no place's DRAWING — it changes
 *  what the map does when a place collides with a pin, a card or the frame. */
export {
  MAP_POI_FOLLOW_UP_DEFAULT,
  MAP_POI_FOLLOW_UP_LABEL,
  MAP_POI_FOLLOW_UPS,
  MapPoiFollowUp,
} from './map-poi-follow-up';
/** The starting surface for map blocks reached through a FENCE, where the block
 *  renderer passes content and nothing else so there is no prop to set. A block
 *  with no provider over it keeps the collapsed tile, as every existing embedder
 *  does. */
export { CmarkdownmapExpansionProvider } from './map-expansion.context';
